import React, { Fragment, useEffect, useRef, useState, useMemo } from 'react';
import Fuse from 'fuse.js';
import AddIcon from "@material-ui/icons/Add";
import { Link } from 'react-router-dom';
import { useForm, Form, useField } from 'react-final-form';

import {
    ArrayInput,
    AutocompleteInput,
    AutocompleteArrayInput,
    BooleanField,
    BooleanInput,
    BulkDeleteButton,
    Button,
    Create,
    Datagrid,
    DateField,
    DeleteButton,
    Edit,
    Filter,
    FormDataConsumer,
    FormTab,
    List,
    maxLength,
    minLength,
    NumberField,
    NumberInput,
    ReferenceField,
    ReferenceInput,
    ReferenceManyField,
    required,
    SelectInput,
    Show,
    SimpleForm,
    SimpleFormIterator,
    Tab,
    TabbedForm,
    TabbedShowLayout,
    TextField,
    TextInput,
    useDataProvider,
    useNotify,
    useQueryWithStore,
    useRefresh,
    useUnselectAll,
    useUpdateMany,
    EditButton,
    ShowButton, CheckboxGroupInput, useGetMany,
    Card,
    CardContent,
    CardActions,
    FormControl,
    InputLabel,
} from 'react-admin';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core';
import { Menu, MenuItem } from '@material-ui/core';
import MuiButton from '@material-ui/core/Button';
import MuiTextField from '@material-ui/core/TextField';
import MuiAutocomplete from "@material-ui/lab/Autocomplete";
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { DatePicker } from '@material-ui/pickers';

import { DateInput as DateInputO } from 'react-admin-date-inputs2';
import { DateInput } from "../../UIComponents/materialDateInput";
import _ from "lodash";
import exporterCommon from "../import/exporterCommon";
import DefaultListActions, { AddItemButton, Empty } from "./common";
import MultiCurrencyField from "../../UIComponents/multiCurrencyField";
import { AddressTab, AddressTabShow } from "./addresses";
import PercentField from "../../UIComponents/PercentField";

import ActiveIcon from "@material-ui/icons/Check"
import SyncIcon from "@material-ui/icons/Sync"
import DeactivateIcon from "@material-ui/icons/Remove"
import EditIcon from "@material-ui/icons/Edit";
import GetAppIcon from "@material-ui/icons/GetApp";
import { EndDateInput } from "../../UIComponents/endDateInput";
import ConditionalField from "../../UIComponents/conditionalField";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import EmployeeBulkActionDialog from "../dialogs/employeeBulkActionsDialog";
import MoveToSitePopover from "../dialogs/moveToSitePopover";
import moment from "moment";
import CaptionedField from "../../UIComponents/captionedField";
import { Typography } from "../../UIComponents/Wrappers";
import ReactToPrint from "react-to-print";
import { useDispatch, useSelector, useStore } from "react-redux";
import { calculateGross, calculateNetPay, getNetPay } from "../../Helpers/salaryCalculator";
import Zemen from "../../UIComponents/ZemenCalendar/zemen";
import ChangeEndDatePopover from "../dialogs/extendDatePopover";
import Divider from "@material-ui/core/Divider";
import ChangeEmploymentTypePopover from "../dialogs/changeEmploymentTypePopover";
import MoveToDepartmentPopover from "../dialogs/moveToDepartmentPopover";
import MoveToCostCenterPopover from '../dialogs/moveToCostCenterPopover';
import MoveToPositionPopover from '../dialogs/moveToPositionPopover';
import ChangeStartDatePopover from "../dialogs/changeStartDatePopover";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';
import { EmployeeAdjustmentCreate } from './employeeAdjustments';
import { ApproveButton, AdjustmentValueField } from './employeeAdjustments';
import CheckIcon from '@material-ui/icons/Check';
import CancelIcon from '@material-ui/icons/Cancel';
import SetCurrentBankPopover from '../dialogs/setCurrentBankPopover';
import { EventShow, AddNewEventButton } from './events';
import { AddNewDeductionButton, AddNewExpenseButton, EditXButton, EditButtonWithEmployeeId } from "./positions";

const deductionChoices = [
    { id: 'EmpPension', name: 'Pension (Employee)' },
    { id: 'PF', name: 'Provident Fund' },
    { id: 'loan', name: 'Repayment' },
    { id: 'Other', name: 'Other' },
]

const expenseChoices = [
    { id: 'CompanyPension', name: 'Pension (Company)' },
    { id: 'CompanyPF', name: 'Provident Fund(Company)' },
    { id: 'Health Insurance', name: 'Health Insurance' },
    { id: 'Other', name: 'Other' },
]

const employeeNameOptionText = (record) => record.fullname ? (record.orgID || '') + " " + record.fullname : "All Employees";
const unnamedName = (type) => (record) => record && record.name ? record.name : 'Unnamed ' + type;

function BulkEarningForm({ formData, form, ...rest }) {
    const { data: templateEarnings } = useQueryWithStore({
        type: 'getList',
        resource: 'earnings',
        payload: { filter: { filter: `Scope eq 'Template'` }, pagination: {}, sort: {} }
    });
    return <Fragment>
        <Grid container style={{ width: "100%" }}>
            <SelectInput onChange={event => {
                const earning = templateEarnings.find(e => e.name === event.target.value)
                if (earning) {
                    form.change('name', earning.name)
                    form.change('taxOption', earning.taxOption)
                    form.change('limitByValue', earning.limitByValue)
                    form.change('valueType', earning.valueType)
                    form.change('dayBased', earning.dayBased)
                    form.change('templateId', earning.id)
                    form.change('basedOn', earning.basedOn)
                    form.change('currency', earning.currency)
                }
            }} source="earningType" optionValue='name' choices={templateEarnings} />
            <TextInput source="name" validate={[required(), minLength(2)]} />
            <ReferenceInput perPage={1000} source="costCenterId" reference="costCenters">
                <AutocompleteInput optionText="name" />
            </ReferenceInput>
        </Grid>
        <SelectInput source="taxOption" choices={[
            { id: 'NonTaxable', name: 'NonTaxable' },
            { id: 'Taxable', name: 'Taxable' },
            { id: 'TaxableWithLimits', name: 'TaxableWithLimits' },
            { id: 'TaxCovered', name: 'Tax Covered By Employer (Add to Net)' }
        ]} />
        {formData.taxOption === 'TaxableWithLimits' &&
            <NumberInput label="Non Taxable Amount" source="limitByValue" />
        }
        <SelectInput source="valueType" choices={[
            { id: 'Absolute', name: 'Absolute' },
            { id: 'Percentage', name: 'Percentage' },
            { id: 'Net', name: 'Net' }
        ]} />
        <SelectInput defaultValue={"ETB"} source="currency" choices={[
            { id: 'ETB', name: 'ETB' },
            { id: 'USD', name: 'USD' },
            { id: 'EUR', name: 'EUR' },
            { id: 'GBP', name: 'GPB' },
        ]} />
        <NumberInput validate={[required()]}
            format={v => formData.valueType === "Percentage" ? ((v * 1000000) / 10000) : v}
            parse={v => formData.valueType === "Percentage" ? (parseFloat(v) / 100) : v}
            source="value" />
        <BooleanInput source="dayBased" />
        <DateInputO source={"startDate"} label="Start date" options={{ format: 'DD/MM/YYYY', inputVariant: 'filled' }} />
        <SelectInput source="basedOn" choices={[
            { id: 'site', name: 'Location Based' },
            { id: 'region', name: 'Region Based' },
        ]} />
    </Fragment>
}

function BulkDeductionForm({ formData, form, ...rest }) {
    const { data: templates } = useQueryWithStore({
        type: 'getList',
        resource: 'deductions',
        payload: { filter: { filter: `Scope eq 'Template'` }, pagination: {}, sort: {} }
    });

    return <Fragment>
        <Grid container style={{ width: "100%" }}>
            <SelectInput label="Template" onChange={event => {
                const item = templates.find(e => e.id === event.target.value)
                form.change('name', item.name)
                form.change('deductionType', item.deductionType)
                form.change('valueType', item.valueType)
                form.change('cash', item.cash)
                form.change('basedOn', item.basedOn)
                form.change('currency', item.currency)
                form.change('dayBased', item.dayBased)
            }} source="templateId" choices={templates} />
            <SelectInput source="deductionType" onChange={value => {
                form.change('name', deductionChoices.find(c => c.id === value.target.value).name)
                form.change('cash', deductionChoices.find(c => c.id === value.target.value).id === 'loan')
            }} choices={deductionChoices} label='Deduction Type' />
            <TextInput source="name" validate={[required(), minLength(2)]} />
            <ReferenceInput perPage={1000} source="costCenterId" reference="costCenters">
                <AutocompleteInput optionText="name" />
            </ReferenceInput>
        </Grid>
        {formData.deductionType !== 'IncomeTax' && (
            <Fragment>
                <SelectInput source="valueType" choices={[
                    { id: 'Absolute', name: 'Absolute' },
                    { id: 'Percentage', name: 'Percentage' },
                    { id: 'NetPercentage', name: 'Percentage From Net' },
                ]} />
                <NumberInput format={v => formData.valueType && formData.valueType.includes("Percentage") ? (v * 1000000) / 10000 : v} parse={v => formData.valueType && formData.valueType.includes("Percentage") ? v / 100 : v} source="value" />
                <DateInputO source={"startDate"} label="Start date" options={{ format: 'DD/MM/YYYY', inputVariant: 'filled', clearable: true }} />
                {(formData.deductionType === 'Other' || formData.deductionType === 'loan') &&
                    <BooleanInput source="cash" />
                }
            </Fragment>
        )}
        <BooleanInput source="dayBased" />
    </Fragment>
}

function BulkExpenseForm({ formData, form, ...rest }) {
    const { data: templates } = useQueryWithStore({
        type: 'getList',
        resource: 'expenses',
        payload: { filter: { filter: `Scope eq 'Template'` }, pagination: {}, sort: {} }
    });

    return <Fragment>
        <SelectInput onChange={event => {
            const item = templates.find(e => e.id === event.target.value)
            form.change('name', item.name)
            form.change('type', item.type)
            form.change('valueType', item.valueType)
            form.change('dayBased', item.dayBased)
            form.change('basedOn', item.basedOn)
            form.change('currency', item.currency)
        }} source="templateId" choices={templates} />
        <SelectInput source="type" onChange={value => form.change('name', expenseChoices.find(c => c.id === value.target.value).name)} choices={expenseChoices} />
        <TextInput source="name" validate={[required(), minLength(2)]} />
        <SelectInput source="valueType" choices={[
            { id: 'Absolute', name: 'Absolute' },
            { id: 'Percentage', name: 'Percentage' },
        ]} />
        <NumberInput format={v => formData.valueType === "Percentage" ? (v * 1000000) / 10000 : v}
            parse={v => formData.valueType === "Percentage" ? v / 100 : v} source="value" />
        <DateInputO source={"startDate"} label="Start date" options={{ format: 'DD/MM/YYYY', inputVariant: 'filled', clearable: true }} />
        <BooleanInput source="dayBased" />
    </Fragment>
}

function BulkEarningsDialog({ open, onClose, selectedIds }) {
    const dataProvider = useDataProvider();
    const notify = useNotify();

    const handleSubmit = async (values) => {
        const promises = selectedIds.map(id =>
            dataProvider.create('earnings', { data: { ...values, employeeId: id, scope: 'Employee' } })
        );
        await Promise.all(promises);
        notify(`${selectedIds.length} earnings added`);
        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
            <DialogTitle>Bulk Add Earnings</DialogTitle>
            <DialogContent>
                <Form onSubmit={handleSubmit} initialValues={{ appliesTo: [], appliesToCitizens: [], scope: 'Employee', dayBased: true }}>
                    {({ handleSubmit: formSubmit, form: formInstance }) => (
                        <form onSubmit={formSubmit}>
                            <BulkEarningForm formData={formInstance.getState().values} form={formInstance} />
                            <DialogActions>
                                <MuiButton onClick={onClose}>Cancel</MuiButton>
                                <MuiButton type="submit" color="primary">Save</MuiButton>
                            </DialogActions>
                        </form>
                    )}
                </Form>
            </DialogContent>
        </Dialog>
    );
};

function BulkDeductionsDialog({ open, onClose, selectedIds }) {
    const dataProvider = useDataProvider();
    const notify = useNotify();

    const handleSubmit = async (values) => {
        const promises = selectedIds.map(id =>
            dataProvider.create('deductions', { data: { ...values, employeeId: id, scope: 'Employee' } })
        );
        await Promise.all(promises);
        notify(`${selectedIds.length} deductions added`);
        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
            <DialogTitle>Bulk Add Deductions</DialogTitle>
            <DialogContent>
                <Form onSubmit={handleSubmit} initialValues={{ appliesTo: [], appliesToCitizens: [], scope: 'Employee', cash: false, dayBased: true }}>
                    {({ handleSubmit: formSubmit, form: formInstance }) => (
                        <form onSubmit={formSubmit}>
                            <BulkDeductionForm formData={formInstance.getState().values} form={formInstance} />
                            <DialogActions>
                                <MuiButton onClick={onClose}>Cancel</MuiButton>
                                <MuiButton type="submit" color="primary">Save</MuiButton>
                            </DialogActions>
                        </form>
                    )}
                </Form>
            </DialogContent>
        </Dialog>
    );
};

function BulkExpensesDialog({ open, onClose, selectedIds }) {
    const dataProvider = useDataProvider();
    const notify = useNotify();

    const handleSubmit = async (values) => {
        const promises = selectedIds.map(id =>
            dataProvider.create('expenses', { data: { ...values, employeeId: id, scope: 'Employee' } })
        );
        await Promise.all(promises);
        notify(`${selectedIds.length} expenses added`);
        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
            <DialogTitle>Bulk Add Expenses</DialogTitle>
            <DialogContent>
                <Form onSubmit={handleSubmit} initialValues={{ appliesTo: [], appliesToCitizens: [], scope: 'Employee', dayBased: true }}>
                    {({ handleSubmit: formSubmit, form: formInstance }) => (
                        <form onSubmit={formSubmit}>
                            <BulkExpenseForm formData={formInstance.getState().values} form={formInstance} />
                            <DialogActions>
                                <MuiButton onClick={onClose}>Cancel</MuiButton>
                                <MuiButton type="submit" color="primary">Save</MuiButton>
                            </DialogActions>
                        </form>
                    )}
                </Form>
            </DialogContent>
        </Dialog>
    );
};

function RemovePensionDialog({ open, onClose, selectedIds }) {
    const dataProvider = useDataProvider();
    const notify = useNotify();
    const refresh = useRefresh();

    const handleRemove = async () => {
        const filter = `employeeId in (${selectedIds.join(',')})`;

        const { data: deductions } = await dataProvider.getList('deductions', {
            filter: { filter: `${filter} and deductionType eq 'EmpPension'` },
            pagination: { page: 1, perPage: 10000 },
            sort: { field: 'id', order: 'ASC' }
        });

        const { data: expenses } = await dataProvider.getList('expenses', {
            filter: { filter: `${filter} and type eq 'CompanyPension'` },
            pagination: { page: 1, perPage: 10000 },
            sort: { field: 'id', order: 'ASC' }
        });

        const deductionIds = deductions.map(d => d.id);
        const expenseIds = expenses.map(e => e.id);
        let removedCount = 0;

        if (deductionIds.length > 0) {
            await dataProvider.deleteMany('deductions', { ids: deductionIds });
            removedCount += deductionIds.length;
        }

        if (expenseIds.length > 0) {
            await dataProvider.deleteMany('expenses', { ids: expenseIds });
            removedCount += expenseIds.length;
        }

        notify(`Removed ${removedCount} pension entries from ${selectedIds.length} employees`);
        refresh();
        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Remove Pension</DialogTitle>
            <DialogContent>
                This will remove EmpPension from deductions and CompanyPension from expenses for {selectedIds.length} selected employees.
            </DialogContent>
            <DialogActions>
                <MuiButton onClick={onClose}>Cancel</MuiButton>
                <MuiButton onClick={handleRemove} color="primary">Remove</MuiButton>
            </DialogActions>
        </Dialog>
    );
};

const typeConfig = {
    earnings: { resource: 'earnings', label: 'Earnings', templateField: 'templateId' },
    deductions: { resource: 'deductions', label: 'Deductions', templateField: 'templateId' },
    expenses: { resource: 'expenses', label: 'Expenses', templateField: 'templateId' },
};

function BulkRemoveItemsDialog({ open, onClose, selectedIds }) {
    const dataProvider = useDataProvider();
    const notify = useNotify();
    const refresh = useRefresh();
    const [type, setType] = useState('earnings');
    const [templateId, setTemplateId] = useState('');
    const [name, setName] = useState('');

    const { data: templates } = useQueryWithStore({
        type: 'getList',
        resource: typeConfig[type].resource,
        payload: { filter: { filter: `Scope eq 'Template'` }, pagination: {}, sort: {} }
    });

    const handleRemove = async () => {
        if (!templateId && !name.trim()) {
            notify('Please select a template or enter a name', 'warning');
            return;
        }

        const config = typeConfig[type];
        const filter = `employeeId in (${selectedIds.join(',')})`;
        let conditions = [];
        if (templateId) {
            conditions.push(`${config.templateField} eq ${templateId}`);
        }
        if (name.trim()) {
            conditions.push(`name eq '${name.trim()}'`);
        }
        const fullFilter = conditions.length > 1
            ? `${filter} and (${conditions.join(' or ')})`
            : `${filter} and ${conditions[0]}`;

        try {
            const { data: items } = await dataProvider.getList(config.resource, {
                filter: { filter: fullFilter },
                pagination: { page: 1, perPage: 10000 },
                sort: { field: 'id', order: 'ASC' }
            });

            if (items.length === 0) {
                notify('No matching items found', 'warning');
                return;
            }

            await dataProvider.deleteMany(config.resource, { ids: items.map(i => i.id) });
            notify(`Removed ${items.length} ${config.label.toLowerCase()} from ${selectedIds.length} employees`);
            refresh();
            onClose();
        } catch (e) {
            notify(`Error: ${e.message}`, 'warning');
        }
    };

    const handleTypeChange = (e) => {
        setType(e.target.value);
        setTemplateId('');
        setName('');
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>Bulk Remove Items</DialogTitle>
            <DialogContent>
                <div style={{ minWidth: 300 }}>
                    <p>Remove {typeConfig[type].label.toLowerCase()} from {selectedIds.length} selected employees.</p>
                    <MuiTextField
                        label="Type"
                        select
                        value={type}
                        onChange={handleTypeChange}
                        fullWidth
                        style={{ marginTop: 8 }}
                    >
                        <MenuItem value="earnings">Earnings</MenuItem>
                        <MenuItem value="deductions">Deductions</MenuItem>
                        <MenuItem value="expenses">Expenses</MenuItem>
                    </MuiTextField>
                    <MuiTextField
                        label="Template"
                        select
                        value={templateId}
                        onChange={e => setTemplateId(e.target.value)}
                        fullWidth
                        style={{ marginTop: 16 }}
                    >
                        <MenuItem value="">-- None --</MenuItem>
                        {(templates || []).map(t => (
                            <MenuItem key={t.id} value={t.id}>{t.name}</MenuItem>
                        ))}
                    </MuiTextField>
                    <MuiTextField
                        label="Name (optional)"
                        value={name}
                        onChange={e => setName(e.target.value)}
                        fullWidth
                        style={{ marginTop: 16 }}
                        helperText="Use when items were created without a template"
                    />
                </div>
            </DialogContent>
            <DialogActions>
                <MuiButton onClick={onClose}>Cancel</MuiButton>
                <MuiButton onClick={handleRemove} color="primary">Remove</MuiButton>
            </DialogActions>
        </Dialog>
    );
};

const GrossUpReportDialog = ({ open, onClose, report }) => {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>Gross Up Report</DialogTitle>
            <DialogContent>
                <p>Processed: {report.processed}</p>
                <p>Skipped: {report.skipped}</p>
                <p>Errors: {report.errors}</p>
                <pre style={{ maxHeight: 400, overflow: 'auto', background: '#f5f5f5', padding: 10 }}>
                    {report.logs.join('\n')}
                </pre>
            </DialogContent>
            <DialogActions>
                <MuiButton onClick={onClose}>Close</MuiButton>
            </DialogActions>
        </Dialog>
    );
};

function BulkSetBasicSalaryDialog({ open, onClose, selectedIds }) {
    const dataProvider = useDataProvider();
    const notify = useNotify();
    const refresh = useRefresh();
    const [value, setValue] = useState('');
    const [currency, setCurrency] = useState('ETB');

    const handleSubmit = async () => {
        const basicSalary = parseFloat(value);
        if (isNaN(basicSalary) || basicSalary < 0) {
            notify('Please enter a valid salary value', 'warning');
            return;
        }

        let processed = 0;
        let errors = 0;

        for (const id of selectedIds) {
            try {
                const { data: employee } = await dataProvider.getOne('employees', { id });
                await dataProvider.update('employees', {
                    id,
                    data: { basicSalary, basicCurrency: currency },
                    previousData: employee,
                });
                processed++;
            } catch (e) {
                errors++;
            }
        }

        notify(`${processed} employees updated${errors ? `, ${errors} errors` : ''}`);
        refresh();
        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Set Basic Salary</DialogTitle>
            <DialogContent>
                <div style={{ minWidth: 300 }}>
                    <p>Set basic salary for {selectedIds.length} selected employees:</p>
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <MuiTextField
                                label="Basic Salary"
                                type="number"
                                value={value}
                                onChange={e => setValue(e.target.value)}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <MuiTextField
                                label="Currency"
                                select
                                value={currency}
                                onChange={e => setCurrency(e.target.value)}
                                fullWidth
                            >
                                <MenuItem value="ETB">ETB</MenuItem>
                                <MenuItem value="USD">USD</MenuItem>
                                <MenuItem value="EUR">EUR</MenuItem>
                                <MenuItem value="GBP">GBP</MenuItem>
                            </MuiTextField>
                        </Grid>
                    </Grid>
                </div>
            </DialogContent>
            <DialogActions>
                <MuiButton onClick={onClose}>Cancel</MuiButton>
                <MuiButton onClick={handleSubmit} color="primary">Set Salary</MuiButton>
            </DialogActions>
        </Dialog>
    );
};

function BulkSalaryIncrementDialog({ open, onClose, selectedIds }) {
    const dataProvider = useDataProvider();
    const notify = useNotify();
    const refresh = useRefresh();
    const { payrollDate, offsetDays } = useSelector(state => state.runPayroll);
    // same formula the payroll reducer uses for periodStart (runPayrollReducer.js:1832).
    // periodStart itself is only correct once a payroll has been loaded, it defaults to now,
    // so derive it from payrollDate which is always set to the start of the payroll month.
    const defaultEffectiveDate = useMemo(
        () => moment(payrollDate).add(offsetDays || 0, 'days').startOf('day').toDate(),
        [payrollDate, offsetDays]
    );
    const [increment, setIncrement] = useState('');
    const [effectiveDate, setEffectiveDate] = useState(defaultEffectiveDate);
    const [remarks, setRemarks] = useState('');
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        if (open) {
            setIncrement('');
            setRemarks('');
            setEffectiveDate(defaultEffectiveDate);
        }
    }, [open, defaultEffectiveDate]);

    const handleCreate = async (applyAdjustment) => {
        const amount = parseFloat(increment);
        if (isNaN(amount) || amount <= 0) {
            notify('Please enter a valid increment amount', 'warning');
            return;
        }
        if (!effectiveDate) {
            notify('Please select an effective date', 'warning');
            return;
        }

        setSubmitting(true);
        const adjustmentName = `${moment(effectiveDate).format('MMM')}-Salary`;
        let created = 0;
        let applied = 0;
        let skipped = 0;
        let errors = 0;

        for (const id of selectedIds) {
            try {
                const { data: employee } = await dataProvider.getOne('employees', { id });
                if (employee.basicSalary === undefined || employee.basicSalary === null) {
                    skipped++;
                    continue;
                }

                const currency = employee.basicCurrency || 'ETB';
                const newBasicSalary = +(employee.basicSalary + amount).toFixed(2);

                const { data: adjustment } = await dataProvider.create('employeeAdjustments', {
                    data: {
                        employeeId: id,
                        name: adjustmentName,
                        adjustmentType: 'Salary',
                        effectiveDate: effectiveDate,
                        oldValue: employee.basicSalary,
                        value: newBasicSalary,
                        currency: currency,
                        description: `Salary increment of ${amount} ${currency}`,
                        remarks: remarks,
                        status: 'Pending',
                    }
                });
                created++;

                if (applyAdjustment) {
                    await dataProvider.serverAction('employeeAdjustments', { id: adjustment.id, action: 'apply' });
                    await dataProvider.update('employees', {
                        id,
                        data: {
                            basicSalary: newBasicSalary,
                            prevBasicSalary: employee.basicSalary,
                            newBasicSalaryStartDate: effectiveDate,
                            salaryAdjustmentRemarks: remarks || 'Salary Increment',
                        },
                        previousData: employee,
                    });
                    applied++;
                }
            } catch (e) {
                errors++;
            }
        }

        setSubmitting(false);
        refresh();
        notify(
            `${applyAdjustment ? applied : created} salary adjustment(s) ${applyAdjustment ? 'created and applied' : 'created'}` +
            `${skipped || errors ? `, ${skipped} skipped, ${errors} errors` : ''}`
        );
        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>Salary Increment</DialogTitle>
            <DialogContent>
                <div style={{ minWidth: 300 }}>
                    <p>Create a salary adjustment for {selectedIds.length} selected employee(s).</p>
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <MuiTextField
                                label="Increment Amount"
                                type="number"
                                value={increment}
                                onChange={e => setIncrement(e.target.value)}
                                fullWidth
                                helperText="In each employee's basic currency"
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <DatePicker
                                label="Effective Date"
                                value={effectiveDate}
                                onChange={setEffectiveDate}
                                fullWidth
                                helperText={`Defaults to the payroll period start (${moment(defaultEffectiveDate).format('DD/MM/YYYY')})`}
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <MuiTextField
                                label="Remarks"
                                value={remarks}
                                onChange={e => setRemarks(e.target.value)}
                                fullWidth
                                multiline
                                rows={2}
                            />
                        </Grid>
                    </Grid>
                </div>
            </DialogContent>
            <DialogActions>
                <MuiButton onClick={onClose} disabled={submitting}>Cancel</MuiButton>
                <MuiButton onClick={() => handleCreate(false)} disabled={submitting}>Create</MuiButton>
                <MuiButton onClick={() => handleCreate(true)} color="primary" disabled={submitting}>
                    {submitting ? 'Processing...' : 'Create and Apply'}
                </MuiButton>
            </DialogActions>
        </Dialog>
    );
};

function BulkGrossUpDialog({ open, onClose, selectedIds }) {
    const dataProvider = useDataProvider();
    const notify = useNotify();
    const refresh = useRefresh();
    const store = useStore();
    const [reportOpen, setReportOpen] = useState(false);
    const [report, setReport] = useState({ processed: 0, skipped: 0, errors: 0, logs: [] });

    const handleGrossUp = async () => {
        const logs = [];
        let processed = 0;
        let skipped = 0;
        let errors = 0;

        for (const id of selectedIds) {
            let employee;
            try {
                const result = await dataProvider.getOne('employees', { id });
                employee = result.data;
                if (!employee.desiredNet || employee.desiredNet <= 0) {
                    skipped++;
                    logs.push(`Skipped: ${employee.fullname || employee.orgID} (no desiredNet)`);
                    continue;
                }

                const { basic } = await calculateGross(id, employee.desiredNet, dataProvider, store);
                await dataProvider.update('employees', {
                    id,
                    data: { basicSalary: basic },
                    previousData: employee,
                });
                processed++;
                logs.push(`Processed: ${employee.fullname || employee.orgID} - Basic set to ${basic.toFixed(2)}`);
            } catch (e) {
                errors++;
                logs.push(`Error: ${(employee && employee.fullname) || (employee && employee.orgID) || id} - ${e.message}`);
            }
        }

        setReport({ processed, skipped, errors, logs });
        setReportOpen(true);
        refresh();
        notify(`Gross Up completed: ${processed} processed, ${skipped} skipped, ${errors} errors`);
    };

    return (
        <>
            <Dialog open={open} onClose={onClose}>
                <DialogTitle>Bulk Gross Up</DialogTitle>
                <DialogContent>
                    This will calculate basic salary from desired net for {selectedIds.length} selected employees. Employees without desiredNet will be skipped.
                </DialogContent>
                <DialogActions>
                    <MuiButton onClick={onClose}>Cancel</MuiButton>
                    <MuiButton onClick={handleGrossUp} color="primary">Gross Up</MuiButton>
                </DialogActions>
            </Dialog>
            <GrossUpReportDialog open={reportOpen} onClose={() => { setReportOpen(false); onClose(); }} report={report} />
        </>
    );
};

const ActiveEmployeeButton = ({ label, active, selectedIds, loading, redirect, record }) => {
    // const {, record,redirect,id, } = props
    const refresh = useRefresh();
    const notify = useNotify();
    const unselectAll = useUnselectAll();
    const [updateMany] = useUpdateMany(
        'employees',
        selectedIds,
        { active },
        {
            onSuccess: () => {
                refresh();
                notify(active ? "Employees Activated" : "Employees Deactivated");
                unselectAll('employees');
            },
            onFailure: error => notify('Error: Employees not updated', 'warning'),
        }
    );



    return (
        <Button
            label={label}
            onClick={updateMany}
        >
            {active ? <ActiveIcon /> : <DeactivateIcon />}
        </Button>
    );
};

const DownloadCsvButton = ({ selectedIds }) => {
    const notify = useNotify();
    const { data, loading } = useGetMany('employees', selectedIds);

    const handleDownload = () => {
        if (data && data.length > 0) {
            exporterCommon('employees')(data);
            notify('CSV downloaded successfully');
        } else {
            notify('No employees selected', 'warning');
        }
    };

    return (
        <Button
            label="Download CSV"
            onClick={handleDownload}
            disabled={loading}
        >
            <GetAppIcon />
        </Button>
    );
};

const client = localStorage.getItem('client') ? localStorage.getItem('client').toLowerCase() : process.env.REACT_APP_CLIENT;

const EmployeeBulkActionButtons = props => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [earningsDialogOpen, setEarningsDialogOpen] = useState(false);
    const [deductionsDialogOpen, setDeductionsDialogOpen] = useState(false);
    const [expensesDialogOpen, setExpensesDialogOpen] = useState(false);
    const [removePensionDialogOpen, setRemovePensionDialogOpen] = useState(false);
    const [grossUpDialogOpen, setGrossUpDialogOpen] = useState(false);
    const [setBasicSalaryDialogOpen, setSetBasicSalaryDialogOpen] = useState(false);
    const [salaryIncrementDialogOpen, setSalaryIncrementDialogOpen] = useState(false);
    const [removeItemsDialogOpen, setRemoveItemsDialogOpen] = useState(false);

    return (
        <Fragment>
            <DownloadCsvButton selectedIds={props.selectedIds} />
            <SetCurrentBankPopover label="Set Current Bank" {...props} />
            <MoveToSitePopover label="Move to Site" {...props} />
            <MoveToDepartmentPopover label="Move to Department" {...props} />
            <MoveToCostCenterPopover label="Move to CostCenter" {...props}/>
            <MoveToPositionPopover label="Move to Position" {...props}/>
            <ChangeEmploymentTypePopover label="Change Employment Type" {...props} />
            <ChangeEndDatePopover label="Change End Date" {...props} />
            <ChangeStartDatePopover label="Change Start Date" {...props} />
            {props.filterValues.active && <ActiveEmployeeButton active={false} label="Deactivate Selected" {...props} />}
            {!props.filterValues.active && <ActiveEmployeeButton active={true} label="Activate Selected" {...props} />}
            <EmployeeBulkActionDialog label="Other Actions" {...props} />
        <BulkDeleteButton {...props} />
        <Button
            label="More Bulk Actions"
            onClick={(event) => setAnchorEl(event.currentTarget)}
        >
            <MoreVertIcon />
        </Button>
        <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={() => setAnchorEl(null)}
        >
            <MenuItem onClick={() => { setAnchorEl(null); setEarningsDialogOpen(true); }}>Earnings</MenuItem>
            <MenuItem onClick={() => { setAnchorEl(null); setDeductionsDialogOpen(true); }}>Deductions</MenuItem>
            <MenuItem onClick={() => { setAnchorEl(null); setExpensesDialogOpen(true); }}>Expenses</MenuItem>
            <MenuItem onClick={() => { setAnchorEl(null); setRemovePensionDialogOpen(true); }}>Remove Pension</MenuItem>
            <MenuItem onClick={() => { setAnchorEl(null); setRemoveItemsDialogOpen(true); }}>Remove Items</MenuItem>
            <MenuItem onClick={() => { setAnchorEl(null); setGrossUpDialogOpen(true); }}>Gross Up</MenuItem>
            <MenuItem onClick={() => { setAnchorEl(null); setSetBasicSalaryDialogOpen(true); }}>Set Basic Salary</MenuItem>
            <MenuItem onClick={() => { setAnchorEl(null); setSalaryIncrementDialogOpen(true); }}>Salary Increment</MenuItem>
        </Menu>
        <BulkEarningsDialog open={earningsDialogOpen} onClose={() => setEarningsDialogOpen(false)} selectedIds={props.selectedIds} />
        <BulkDeductionsDialog open={deductionsDialogOpen} onClose={() => setDeductionsDialogOpen(false)} selectedIds={props.selectedIds} />
        <BulkExpensesDialog open={expensesDialogOpen} onClose={() => setExpensesDialogOpen(false)} selectedIds={props.selectedIds} />
        <RemovePensionDialog open={removePensionDialogOpen} onClose={() => setRemovePensionDialogOpen(false)} selectedIds={props.selectedIds} />
        <BulkGrossUpDialog open={grossUpDialogOpen} onClose={() => setGrossUpDialogOpen(false)} selectedIds={props.selectedIds} />
        <BulkSetBasicSalaryDialog open={setBasicSalaryDialogOpen} onClose={() => setSetBasicSalaryDialogOpen(false)} selectedIds={props.selectedIds} />
        <BulkSalaryIncrementDialog open={salaryIncrementDialogOpen} onClose={() => setSalaryIncrementDialogOpen(false)} selectedIds={props.selectedIds} />
        <BulkRemoveItemsDialog open={removeItemsDialogOpen} onClose={() => setRemoveItemsDialogOpen(false)} selectedIds={props.selectedIds} />

        </Fragment>
    );
};

const EmployeeNameFilter = () => {
    const { input: idInput } = useField('id', { subscription: { value: true } });
    const { data: employees } = useQueryWithStore({
        type: 'getList',
        resource: 'employees',
        payload: { filter: {}, pagination: { page: 1, perPage: 10000 }, sort: { field: 'fullname', order: 'ASC' } }
    });

    const fuseOptions = useMemo(() => ({
        keys: ['fullname', 'orgID'],
        threshold: 0.3,
    }), []);

    const fuse = useMemo(() =>
        employees ? new Fuse(employees, fuseOptions) : null,
    [employees, fuseOptions]);

    return (
        <MuiAutocomplete
            value={(employees && idInput.value && employees.find(e => e.id === idInput.value)) || null}
            options={employees || []}
            getOptionLabel={(option) => (option.orgID || '') + ' ' + (option.fullname || '')}
            filterOptions={(options, { inputValue }) => {
                if (!inputValue) return options.slice(0, 50);
                if (!fuse) return [];
                return fuse.search(inputValue).map(r => r.item);
            }}
            onChange={(event, value) => {
                idInput.onChange(value ? value.id : undefined);
            }}
            renderOption={(option) => (
                <span>
                    {(option.orgID || '') + ' ' + (option.fullname || '')}
                    {!option.active && (
                        <CancelIcon style={{ color: 'red', fontSize: 16, marginLeft: 8, verticalAlign: 'middle' }} />
                    )}
                </span>
            )}
            renderInput={(params) => (
                <MuiTextField {...params} label="Employee Name" variant="standard" style={{ minWidth: 350 }} />
            )}
            noOptionsText="No employees found"
            clearOnEscape
        />
    );
};

const EmployeeFilter = (props) => (
    <Filter {...props}>
        <BooleanInput source="active" alwaysOn />
        <EmployeeNameFilter source="id" alwaysOn />


        {/* <ReferenceInput perPage={5000} label="Employee Name" emptyText="All Employees" allowEmpty source="id" reference="employees" alwaysOn >
            <AutocompleteInput allowEmpty={true} optionText={employeeNameOptionText} options={{ type: 'search' }} />
        </ReferenceInput > */}
        <ReferenceInput perPage={2000} label="Department" source="departmentId" reference="departments" >
          <AutocompleteInput allowEmpty={true} optionText={unnamedName('Department')} options={{ type: 'search' }} />
        </ReferenceInput>
        <ReferenceInput perPage={2000} label="CostCenter" source="costCenterId" reference="costCenters" >
            <AutocompleteInput allowEmpty={true} optionText={unnamedName('CostCenter')} options={{ type: 'search' }} />
        </ReferenceInput>
        <ReferenceInput perPage={2000} label="Current Site" source="siteId" reference="sites" >
            <AutocompleteInput allowEmpty={true} optionText={unnamedName('Site')} options={{ type: 'search' }} />
        </ReferenceInput>

        <ReferenceInput perPage={2000} label="Current Region" source="site/regionId" reference="regions" >
            <AutocompleteInput allowEmpty={true} optionText={unnamedName('Region')} options={{ type: 'search' }} />
        </ReferenceInput>

        <DateInput source="startDate" label="Start Date" options={{ format: 'DD/MM/YYYY', inputVariant: 'filled' }} />
        <DateInput source="contractEndDate" label="End Date" options={{ format: 'DD/MM/YYYY', inputVariant: 'filled' }} />

        <ReferenceInput perPage={1000} label="Position" source="positionId" reference="positions" >
            <AutocompleteInput allowEmpty={true} optionText={unnamedName('Position')} options={{ type: 'search' }} />
        </ReferenceInput>
        <SelectInput defaultValue={"FullTime"} source="employmentType" choices={[
            { id: 'FullTime', name: 'FullTime' },
            { id: 'Contract', name: 'Contract' },
            { id: 'PartTime', name: 'PartTime' },
            { id: 'InternOrFellow', name: 'InternOrFellow' },
            { id: 'Casual', name: 'Casual' },
        ]} />

        <SelectInput defaultValue={"Ethiopian"} source="citizenship" choices={[
            { id: 'Ethiopian', name: 'Ethiopian' },
            { id: 'Non-Ethiopian', name: 'Non-Ethiopian' }
        ]} />
    </Filter>
);

const postRowStyle = (record, index) => ({
    backgroundColor: record.contractEndDate && moment(record.contractEndDate) > moment("1970/1/1") && moment(record.contractEndDate) < moment() ? '#ffcb7d' : 'white',
});
const PrintContainer = props =>
    <div ref={props.comRef}><Datagrid rowStyle={postRowStyle} {...props} rowClick="show">
        <TextField label="Work Id" source="orgID" />
        <TextField source="fullname" />
        <MultiCurrencyField source="basicSalary" />
        <ReferenceField source="positionId" reference="positions">
            <TextField source="name" />
        </ReferenceField>
        <TextField source="employmentType" />
        <ReferenceField source="siteId" reference="sites">
            <TextField source="name" />
        </ReferenceField>
        <ReferenceField source="costCenterId" reference="costCenters">
            <TextField source="name" />
        </ReferenceField>
        <DateField source="startDate" />
        <DateField source="contractEndDate" />
        <ShowButton label={'Detail'} className='no-print' />
        <EditButton className='no-print' />
    </Datagrid>
    </div>

const EmployeeActions = props => {
    const dispatch = useDispatch();
    return <>
        {localStorage.getItem('companyMateId') && <Button startIcon={<SyncIcon />} label="Sync" onClick={() => dispatch({ type: 'LOAD_TIK_MATES_CHANGES' })} />}
        {/*<DefaultListActions {...props}  />*/}
    </>
}

export const EmployeeList = props => {
    const componentRef = useRef();
    return <List perPage={150} className="all-boarder" bulkActionButtons={<EmployeeBulkActionButtons />} exporter={exporterCommon(props.resource)}
        actions={<DefaultListActions extra={<EmployeeActions />} componentRef={componentRef} />} empty={<Empty />} filters={<EmployeeFilter />}
        filterDefaultValues={{ active: true }}   {...props}>
        <PrintContainer comRef={componentRef} />
    </List>



    // <List ref={componentRef} className="all-boarder" perPage={1000} bulkActionButtons={<EmployeeBulkActionButtons/>} exporter={exporterCommon(props.resource)}
    //       actions={<DefaultListActions  />} empty={<Empty/>} filters={<EmployeeFilter/>}
    //       filterDefaultValues={{active: true}}   {...props}>
    //     <Datagrid  rowClick="show">
    //         <TextField label="Work Id" source="orgID"/>
    //         <TextField source="fullname"/>
    //         <MultiCurrencyField source="basicSalary"/>
    //         <ReferenceField source="positionId" reference="positions">
    //             <TextField source="name"/>
    //         </ReferenceField>
    //         <TextField source="employmentType"/>
    //         <BooleanField source="active"/>
    //         <EditButton/>
    //     </Datagrid>
    // </List>

};

export const EmployeeEdit = props => (
    <Edit {...props}>
        <TabbedForm redirect='list'  >
            {/*<FormTab label="Basic Info">*/}
            {/*<BooleanInput  source="active"/>*/}

            {/*<ReferenceInput  label="Position" source="positionId" reference="positions" validate={[required()]}>*/}
            {/*<SelectInput optionText="name" />*/}
            {/*</ReferenceInput>*/}
            {/*<TextInput source="name" />*/}
            {/*<TextInput    source="fatherName" />*/}
            {/*<TextInput   source="gFatherName" />*/}
            {/*<SelectInput  source="gender"  choices={[*/}
            {/*{ id: 'Female', name: 'Female' },*/}
            {/*{ id: 'Male', name: 'Male' },*/}
            {/*]}  />*/}
            {/*<TextInput   source="tinNo" validate={[maxLength(15)]} />*/}
            {/*<TextInput   source="pensionNo" validate={[maxLength(15)]} />*/}
            {/*<SelectInput  defaultValue={"Ethiopian"} source="citizenship"  choices={[*/}
            {/*{ id: 'Ethiopian', name: 'Ethiopian' },*/}
            {/*{ id: 'Foreign', name: 'Foreign' },*/}
            {/*]}  />*/}
            {/*<SelectInput defaultValue={"FullTime"} source="employmentType"  choices={[*/}
            {/*{ id: 'FullTime', name: 'FullTime' },*/}
            {/*{ id: 'Contract', name: 'Contract' },*/}
            {/*]}  />*/}
            {/*<DateInput source="contractEndDate"  />*/}
            {/*<ReferenceInput   filter={{ expand:'bank' }}  label="Bank" source="companyBankId" reference="companyBanks" validate={[required()]}>*/}
            {/*<SelectInput optionText="bank.name" />*/}
            {/*</ReferenceInput>*/}
            {/*<TextInput label="Branch"   source="bankBranch" />*/}
            {/*<TextInput   source="bankAccountNumber" />*/}
            {/*<NumberInput    source="basicSalary" />*/}
            {/*<TextInput label='Email' type='email' validate={email()}   source="address.email" />*/}
            {/*</FormTab>*/}
            <FormDataConsumer>
                {formDataProps => (
                    <EmployeeBasic {...formDataProps} />
                )}
            </FormDataConsumer>
            <AddressTab />
            <FormDataConsumer>
                {formDataProps => (
                    <MiscForm {...formDataProps} />
                )}
            </FormDataConsumer>
        </TabbedForm>

    </Edit>
);

const ChangeEarnings = (positionId, dataProvider, form, employmentType, citizenship) => {

    dataProvider.getOne('positions', { id: positionId, expand: 'earnings,deductions,expenses,department' })
        .then(({ data }) => {



            const e = data.earnings.filter(e => e.appliesTo.includes(employmentType) && (!citizenship || !e.appliesToCitizens || !e.appliesToCitizens.length || e.appliesToCitizens.map(ap => ap.toLowerCase()).includes(citizenship.toLowerCase().replace(/\s+/g, '')))).map(e => {
                // console.log(e)
                const f = _.omit(e, ["id", "createdDate", "modifiedDate", "version", "@odata.context", "@odata.etag", "positionId", "employeeId"])
                f.parentScope = f.scope
                f.scope = "Employee"
                f.copyRefId = e.id
                //  f.earningType = e.earningType
                return f
            })

            const d = data.deductions.filter(e => e.appliesTo.includes(employmentType) && (!citizenship || !e.appliesToCitizens || !e.appliesToCitizens.length || e.appliesToCitizens.map(ap => ap.toLowerCase()).includes(citizenship.toLowerCase().replace(/\s+/g, '')))).map(e => {
                const f = _.omit(e, ["id", "createdDate", "modifiedDate", "version", "@odata.context", "@odata.etag", "positionId", "employeeId"])
                f.parentScope = f.scope
                f.scope = "Employee"
                f.copyRefId = e.id
                return f
            })

            const ex = data.expenses.filter(e => e.appliesTo.includes(employmentType) && (!citizenship || !e.appliesToCitizens || !e.appliesToCitizens.length || e.appliesToCitizens.map(ap => ap.toLowerCase()).includes(citizenship.toLowerCase().replace(/\s+/g, '')))).map(e => {
                const f = _.omit(e, ["id", "createdDate", "modifiedDate", "version", "@odata.context", "@odata.etag", "positionId", "employeeId"])
                f.parentScope = f.scope
                f.scope = "Employee"
                f.copyRefId = e.id
                return f
            })

            //  console.log(e,data.earnings,form.getFieldState('earnings').value.filter(er=>er.parentScope!=="Position").concat(e))
            //
            //   const ee = (form.getFieldState('earnings').value||[]).filter(er=>er.parentScope!=="Position").concat(e)
            //   console.log(ee)
            if (data.department) {
                form.change('departmentId', data.department.id)
            }
            if(data.basicSalary){
                form.change('basicSalary', data.basicSalary)
            }


            form.change('earnings', (form.getFieldState('earnings').value || []).filter(er => er.parentScope !== "Position").concat(e))
            //console.log(form.getFieldState('earnings').value)
            form.change('deductions', (form.getFieldState('deductions').value || []).filter(er => er.parentScope !== "Position").concat(d))
            form.change('expenses', (form.getFieldState('expenses').value || []).filter(er => er.parentScope !== "Position").concat(ex))
        })
}

const setDefaults = (employmentType, form, data, citizenship, dataProvider) => {
    //  console.log(employmentType,form)
    // form.reset()

    // return   dataProvider.getOne('companies', { id: localStorage.getItem('companyId'), expand:`earnings($filter = Scope eq 'Company'),deductions($filter = Scope eq 'Company'),expenses($filter = Scope eq 'Company'),CompanySettings`})
    //       .then(({ data }) => {
    if (data) {
        const e = data.earnings.filter(e => e.appliesTo.includes(employmentType) && (!citizenship || !e.appliesToCitizens || !e.appliesToCitizens.length || e.appliesToCitizens.map(ap => ap.toLowerCase()).includes(citizenship.toLowerCase().replace(/\s+/g, '')))).map(e => {

            const f = _.omit(e, ["id", "appliesTo", "createdDate", "modifiedDate", "version", "@odata.context", "@odata.etag", "positionId", "employeeId"])
            f.parentScope = f.scope
            f.scope = "Employee"
            f.copyRefId = e.id
            return f


        })

        const d = data.deductions.filter(e => e.appliesTo.includes(employmentType) && (!citizenship || !e.appliesToCitizens || !e.appliesToCitizens.length || e.appliesToCitizens.map(ap => ap.toLowerCase()).includes(citizenship.toLowerCase().replace(/\s+/g, '')))).map(e => {

            const f = _.omit(e, ["id", "appliesTo", "createdDate", "modifiedDate", "version", "@odata.context", "@odata.etag", "positionId", "employeeId"])
            f.parentScope = f.scope
            f.scope = "Employee"
            f.copyRefId = e.id
            return f

        })

        const ex = data.expenses.filter(e => e.appliesTo.includes(employmentType) && (!citizenship || !e.appliesToCitizens || !e.appliesToCitizens.length || e.appliesToCitizens.map(ap => ap.toLowerCase()).includes(citizenship.toLowerCase().replace(/\s+/g, '')))).map(e => {

            const f = _.omit(e, ["id", "appliesTo", "createdDate", "modifiedDate", "version", "@odata.context", "@odata.etag", "positionId", "employeeId"])
            f.parentScope = f.scope
            f.scope = "Employee"
            f.copyRefId = e.id
            return f

        })

        //console.log(e)
        //  if(e.fullTime)
        // console.log('deductions',ex)

        form.change('earnings', e)
        form.change('deductions', d)
        form.change('expenses', ex)


        if (form.getFieldState('positionId') && form.getFieldState('positionId').value) {
            ChangeEarnings(form.getFieldState('positionId').value, dataProvider, form, employmentType, citizenship)
        }


        const defaultOtBaseSetting = data.companySettings && data.companySettings.find(c => c.name === "defaultOtBase");
        if (defaultOtBaseSetting) {
            form.change('otBase', defaultOtBaseSetting.value);
            if (defaultOtBaseSetting.value === 'gross') {
                form.change('payGross', true);
            }
        } else if (data.companySettings && data.companySettings.find(c => c.name === "payGross") && data.companySettings.find(c => c.name === "payGross").value === 'true') {
            form.change('payGross', true)
            form.change('otBase', 'gross')
        } else {
            form.change('otBase', 'basic');
        }
        // return data
        // })
    }

}
const MiscForm = props => {
    const form = useForm();
    const [net, setNet] = useState(0);
    const [basic, setBasic] = useState(0);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const dataProvider = useDataProvider();
    const store = useStore();

    //  const {data: fullEmployee } = useQueryWithStore({
    //      type: 'getOne',
    //      resource: 'employees',
    //      payload: {id: props.formData.id, expand:`earnings,deductions`}
    //  });
    //
    //  const {data: taxRules } = useQueryWithStore({
    //      type: 'getList',
    //      resource: 'incomeTaxRules',
    //      payload: {pagination:{},sort:{},filter:{}}
    //  });
    //
    //  // console.log({fullEmployee,taxRules})
    // let net = 0;
    //  useEffect( () =>  {
    //      if(fullEmployee&&taxRules)
    //     net = getNetPay({basicSalary:fullEmployee.basicSalary,payrollFixedEarnings:fullEmployee.earnings,payrollFixedDeductions:fullEmployee.deductions, taxRules})
    //      console.log(net)
    //  }, [fullEmployee,taxRules])
    //

    const handleGetNet = async () => {
        setLoading(true)
        try {
            const desiredNet = props.formData.desiredNet
            const { basic, net } = await calculateGross(props.formData.id, desiredNet, dataProvider, store)
            // console.log({basic,net})
            setBasic(basic)
            form.change("basicSalary", basic)
            form.change("desiredNet", desiredNet)
            // const net =   await calculateNetPay(props.formData.id,dataProvider,store, basic)
            setNet(net)
            setLoading(false)
        }
        catch (e) {
            setError(e.message)
            setLoading(false)
        }

        // console.log(net)
    }


    return <FormTab {...props} label="Miscellaneous">
        <Grid fullWidth container>
            <Grid item md={6}>
                <div>
                    <NumberInput source="outstandingLoan" />
                </div>

                <NumberInput source="remainingLeaveDays" />
                <div>
                    <NumberInput source="desiredNet" />

                    <Button disabled={loading} onClick={handleGetNet} label={`Gross Up`} />
                    {net > 0 && basic > 0 && <div style={{ width: '75%' }}>
                        Basic Salary is Set to ~ {basic.toFixed(3)} to Get Net ~ {net.toFixed(2)}
                    </div>}
                    {error && <div style={{ width: '75%', color: 'red' }}>
                        Please Check the Desired Net Value
                    </div>}
                </div>


                {/*<NumberInput source="defaultOvertime" />*/}
                <SelectInput defaultValue={"ETB"} source="defaultCurrency" choices={[
                    { id: 'ETB', name: 'ETB' },
                    { id: 'USD', name: 'USD' },
                    { id: 'EUR', name: 'EUR' },
                    { id: 'GBP', name: 'GPB' },
                ]} />

                <BooleanInput source="payGross" />

                <SelectInput source="otBase" label="Overtime Base" choices={[
                    { id: 'basic', name: 'Basic Salary' },
                    { id: 'gross', name: 'Basic + Fixed Earnings' },
                    { id: 'desiredNet', name: 'Desired Net' },
                ]} />

                <BooleanInput source="excludeFromDistEarnings" />
                <NumberInput label="Daily Service Hours " source="dailyServiceHour" />



            </Grid>
            <Grid item md={6}>
                <TextInput label="National ID" source="nationalID" />
                <TextInput source="taxRegion" />
                <TextInput source="function" />
                <TextInput source="subFunction" />
                <TextInput source="grade" />
                <NumberInput source="step" />

                <Divider />
                <NumberInput label="Extra Income Tax " source="extraIncomeTax" />
                <TextInput placeholder="Eg. taxableIncome * 0.35" fullWidth label="Custom IncomeTax Expression" source="customIncomeTaxExpression" />

            </Grid>

            <Grid item md={12}>
                <CheckboxGroupInput source="sendPayslipVia" choices={[
                    { id: "Publish", name: 'Publish to Self Service Portal' },
                    { id: "EmailLink", name: 'Email link after Publish' },
                    { id: "Telegram", name: 'Send As Telegram Message' },
                    { id: "DirectEmail", name: 'Directly Email Full Slip' },
                    { id: "None", name: 'Dont Send Payslip' },
                ]} />
            </Grid>

        </Grid>

    </FormTab>

}

const EmployeeBasic = props => {
    const form = useForm();

    const { data: companyData } = useQueryWithStore({
        type: 'getOne',
        resource: 'companies',
        payload: { id: localStorage.getItem('companyId'), expand: `earnings($filter = Scope eq 'Company'),deductions($filter = Scope eq 'Company'),expenses($filter = Scope eq 'Company'),CompanySettings` }
    });

    const { data: companyBanks } = useQueryWithStore({
        type: 'getList',
        resource: 'companyBanks',
        payload: { filter: { expand: `bank` } }
    });
    // console.log(companyBanks)





    //  console.log(form)
    const dataProvider = useDataProvider();
    useEffect(() => {
        if (props.create) {
            //console.log(form)

            setDefaults('FullTime', form, companyData, "Ethiopian", dataProvider)

        }
    }, [companyData, dataProvider, form, props.create])

    const setBank = (e) => {
        const bank = companyBanks.find(b => b.id === e.target.value)
        bank && form.change('bank', bank.bank.name)
        // console.log( bank.bank.name)
    }

    if (!companyData) return null

    return <FormTab {...props} label="Basic Info">
        {!props.create && <BooleanInput source="active" />}
        <Grid container style={{ width: "100%" }}  >
            <TextInput label="Work Id" source="orgID" />
            <TextInput label="Mate Id" source="mateId" />
            <ReferenceInput perPage={1000} label="Site" source="siteId" reference="sites">
                {/*<SelectInput  validate={[required()]} optionText="name"  />*/}
                <AutocompleteInput         allowEmpty={true}
                optionText={unnamedName('Site')}
                options={{ type: 'search' }} />
            </ReferenceInput>
        </Grid>
        <Grid container style={{ width: "100%" }}  >
            <Grid item md={3}>
                <ReferenceInput perPage={1000} onChange={value => props.create && ChangeEarnings(value, dataProvider, form, form.getFieldState('employmentType').value, form.getFieldState('citizenship').value)} label="Position" source="positionId" reference="positions" >
                    {/*<SelectInput  validate={[required()]} optionText="name"  />*/}
                    <AutocompleteInput         allowEmpty={true}
                optionText={unnamedName('Position')}
                options={{ type: 'search' }}  />
                </ReferenceInput>
            </Grid>
            <Grid item md={3}>
                <ReferenceInput perPage={1000} source="departmentId" reference="departments" >
                    {/*<SelectInput  validate={[required()]} optionText="name"  />*/}
                    <AutocompleteInput         allowEmpty={true}
                optionText={unnamedName('Department')}
                options={{ type: 'search' }}  />

                </ReferenceInput>
            </Grid>
            <Grid item md={3}>
                <ReferenceInput perPage={1000} source="costCenterId" reference="costCenters" >
                    {/*<SelectInput  validate={[required()]} optionText="name"  />*/}
                    <AutocompleteInput         allowEmpty={true}
                optionText={unnamedName('CostCenter')}
                options={{ type: 'search' }}  />

                </ReferenceInput>
            </Grid>
        </Grid>
        <Grid container style={{ width: "100%" }}  >
            <Grid item md={1}>
                <AutocompleteInput  clearable source="title" choices={[
                    { id: '', name: 'No Title' },
                    { id: 'Mr.', name: 'Mr.' },
                    { id: 'Ms.', name: 'Ms.' },
                    { id: 'Mrs.', name: 'Mrs.' },
                    {id: 'Ato', name:'Ato'},
                    {id:'W/ro', name:'W/ro'},
                    {id:'W/rt', name:'W/rt'},
                    {id:'Col.', name:'Col.'},
                    {id:'Eng.', name:'Eng.'},
                    { id: 'Dr.', name: 'Dr.' },
                    { id: 'Prof.', name: 'Prof.' },
                    { id: 'Sr.', name: 'Sr.' },
                    { id: 'General', name: 'General' },
                ]} />

            </Grid>
            <Grid item md={3}>
                <TextInput source="name" validate={[required(), minLength(2), maxLength(15)]} />
            </Grid>
            <Grid item md={3}>
                <TextInput source="fatherName" validate={[required(), minLength(2), maxLength(15)]} />
            </Grid>
            <Grid item md={3}>
                <TextInput source="gFatherName" validate={[minLength(2), maxLength(15)]} />

            </Grid>
        </Grid>
        <Grid container style={{ width: "100%" }}  >

            <TextInput source="tinNo" validate={[maxLength(15)]} />
            <TextInput source="pensionNo" validate={[maxLength(15)]} />

        </Grid>
        <Grid container style={{ width: "100%" }}  >
            <SelectInput source="gender" choices={[
                { id: 'M', name: 'Male' },
                { id: 'F', name: 'Female' },
            ]} />
            <SelectInput onChange={ev => props.create && setDefaults(form.getFieldState('employmentType').value, form, companyData, ev.target.value, dataProvider)} defaultValue={"Ethiopian"} source="citizenship" choices={[
                { id: 'Ethiopian', name: 'Ethiopian' },
                { id: 'Non-Ethiopian', name: 'Non-Ethiopian' },
            ]} />
            <DateInput source="dateOfBirth" label="Date of Birth" options={{ format: 'DD/MM/YYYY', inputVariant: 'filled' }} />
        </Grid>
        <SelectInput onChange={ev => {
            props.create && setDefaults(ev.target.value, form, companyData, form.getFieldState('citizenship').value, dataProvider);
            if (ev.target.value === "Contract") {
                form.change("startDate", moment())
            }
        }} defaultValue={"FullTime"} source="employmentType" choices={[
            { id: 'FullTime', name: 'FullTime' },
            { id: 'Contract', name: 'Contract' },
            { id: 'PartTime', name: 'PartTime' },
            { id: 'InternOrFellow', name: 'InternOrFellow' },
            { id: 'Casual', name: 'Casual' },
        ]} />

        {/*<DateInput     source="startDate" label="Start date" options={{ format: 'DD/MM/YYYY', inputVariant:'filled'  }}  input={{onChange:ev=>console.log(ev)}}  />*/}
        <DateInput
            onChange={ev => {
                if (props.create) {
                    const settingDays = companyData.companySettings.find(s => s.name === 'Pension_StartDays')
                    const settingFullMonth = companyData.companySettings.find(s => s.name === 'Pension_FullMonth')
                    const StartAfterDays = settingDays ? +settingDays.value : 0
                    const StartFullMonth = settingFullMonth ? settingFullMonth.value === 'true' : true




                    const deductions = (form.getFieldState('deductions').value || []).slice(0)
                    const expenses = (form.getFieldState('expenses').value || []).slice(0)

                    const pension = deductions.find(d => d.deductionType === "EmpPension")
                    const compPension = expenses.find(d => d.type === "CompanyPension")



                    if (pension) {

                        // console.log(companyData)
                        pension.startDate = moment(ev).add(StartAfterDays, "day")
                        // if(StartFullMonth){
                        //     pension.startDate = pension.startDate.startOf('month')
                        // }
                        form.change('deductions', deductions)

                    }

                    if (compPension) {

                        // console.log(companyData)
                        compPension.startDate = moment(ev).add(StartAfterDays, "day")
                        // if(StartFullMonth){
                        //     compPension.startDate = pension.startDate.startOf('month')
                        // }
                        form.change('expenses', expenses)

                    }

                }





                //  form.change('contractEndDate', val)
            }
            } source="startDate"
            label="Start date" options={{ format: 'DD/MM/YYYY', inputVariant: 'filled' }} />
        <EndDateInput startDate={props.formData.startDate} employmentType={props.formData.employmentType} onDateChange={val => form.change('contractEndDate', val)} source="contractEndDate" label="End Date" options={{ format: 'DD/MM/YYYY' }} />

        <Grid container style={{ width: "100%" }}  >
            <NumberInput label={props.formData.employmentType === 'Casual' ? 'Daily Wadge' : 'Basic Salary'} source="basicSalary" validate={[required()]} />
            <SelectInput defaultValue={"ETB"} label='Currency' source="basicCurrency" choices={[
                { id: 'ETB', name: 'ETB' },
                { id: 'USD', name: 'USD' },
                { id: 'EUR', name: 'EUR' },
                { id: 'GBP', name: 'GPB' },
            ]} />
            {!props.create && <>
                <DateInput onChange={ev=>form.change('prevBasicSalary',props.formData.basicSalary)} source="newBasicSalaryStartDate" options={{ format: 'DD/MM/YYYY', inputVariant: 'filled' }} />
                {props.formData.newBasicSalaryStartDate && <>
                    <NumberInput  source="prevBasicSalary" />
                    <TextInput source="salaryAdjustmentRemarks" />
                </>}
            </>}

        </Grid>


        <Grid container style={{ width: "100%" }}  >
            <ReferenceInput filter={{ expand: 'bank' }} label="Bank" source="companyBankId" reference="companyBanks" onChange={setBank}>
                <SelectInput optionText="bank.name" />
            </ReferenceInput>
            <TextInput source="bankAccountNumber" />
            <TextInput label="Branch" source="bankBranch" />

            <TextInput source="bankAccountHolderName" />
        </Grid>
        <Grid container style={{ width: "100%" }}  >
            <ArrayInput source="bankAccounts">
                <SimpleFormIterator>
                    <FormDataConsumer>
                        {({ getSource, scopedFormData, ...rest }) => (
                            <>
                                <ReferenceInput filter={{ expand: 'bank' }} label="Bank" source={getSource("companyBankId")} reference="companyBanks" onChange={setBank}>
                                    <SelectInput optionText="bank.name" />
                                </ReferenceInput>
                                <TextInput source={getSource("bankAccountNumber")} label="Bank Account Number" />
                                <TextInput source={getSource("bankBranch")} label="Bank Branch" />
                                <TextInput source={getSource("bankAccountHolderName")} label="Bank Account Holder Name" />
                                <Button
                                    label="Set Current"
                                    onClick={() => {
                                        form.change('companyBankId', scopedFormData.companyBankId);
                                        form.change('bankAccountNumber', scopedFormData.bankAccountNumber);
                                        form.change('bankBranch', scopedFormData.bankBranch);
                                        form.change('bankAccountHolderName', scopedFormData.bankAccountHolderName);
                                    }}
                                />
                            </>
                        )}
                    </FormDataConsumer>
                </SimpleFormIterator>
            </ArrayInput>
        </Grid>

    </FormTab>


}
const EarningForm = ({ formData, scopedFormData, index, getSource, ...rest }) => {
    // console.log(scopeText)

    //const [data:templ]
    const { data: templateEarnings } = useQueryWithStore({
        type: 'getList',
        resource: 'earnings',
        payload: { filter: { filter: `Scope eq 'Template'` }, pagination: {}, sort: {} }
    });



    //console.log('index',scopedFormData)
    //console.log('rest',getSource)
    const form = useForm();
    if (!scopedFormData) {
        return null
    }
    return <Fragment>

        <SelectInput onChange={event => {
            const earning = templateEarnings.find(e => e.name === event.target.value)
            // console.log('earning',earning)
            if (earning) {
                form.change(getSource("name"), earning.name)
                form.change(getSource('taxOption'), earning.taxOption)
                form.change(getSource('limitByValue'), earning.limitByValue)
                form.change(getSource('valueType'), earning.valueType)
                form.change(getSource('basedOn'), earning.basedOn)
                form.change(getSource('currency'), earning.currency)
                //    form.change(getSource('earningType'), earning.name)
                form.change(getSource('templateId'), earning.id)

            }
        }}   {...rest} label="Earning Type" source={getSource("earningType")} optionValue='name' choices={templateEarnings} />
        {/*<ReferenceInput*/}
        {/*{...rest}*/}
        {/*source="type"*/}
        {/*reference="earnings"*/}
        {/*filter={{filter:`Scope eq 'Template'`}}*/}
        {/*>*/}

        {/*<SelectInput    optionText="name" />*/}
        {/*</ReferenceInput>*/}
        <TextInput   {...rest} label="Name" source={getSource('name')} />
        <SelectInput  {...rest} label="Tax Option" source={getSource("taxOption")} choices={[
            { id: 'NonTaxable', name: 'NonTaxable' },
            { id: 'Taxable', name: 'Taxable' },
            { id: 'TaxableWithLimits', name: 'TaxableWithLimits' },
        ]} />

        {scopedFormData.taxOption === 'TaxableWithLimits' &&

            <NumberInput  {...rest} label="Non Taxable Amount" source={getSource("limitByValue")} />
        }

        <SelectInput  {...rest} label="ValueType" source={getSource('valueType')} choices={[
            { id: 'Absolute', name: 'Absolute' },
            { id: 'Percentage', name: 'Percentage' },
            {id: 'Net', name:'Net'}
        ]} />



        <NumberInput validate={[required()]} format={v => (scopedFormData.valueType || '').includes("Percentage") ? (v * 1000000) / 10000 : v} parse={v => (scopedFormData.valueType || '').includes("Percentage") ? v / 100 : v}  {...rest} label='Value' source={getSource("value")} />

    </Fragment>
}
const EmployeeEarning = props => {

    return <FormTab {...props} label="Earnings">
        <NumberInput source="basicSalary" />
        <ArrayInput label='Additional Earnings' source="earnings">
            <SimpleFormIterator  >
                <FormDataConsumer>
                    {formDataProps => (
                        <EarningForm {...formDataProps} />
                    )}
                </FormDataConsumer>
                {/*<TextInput label="Name" source="name" />*/}
                {/*<SelectInput label="Value Type"  source="valueType"  choices={[*/}
                {/*    { id: 'Absolute', name: 'Absolute' },*/}
                {/*    { id: 'Percentage', name: 'Percentage' },*/}
                {/*]}  />*/}

                {/*<NumberInput label="Value"  source="value" />*/}
            </SimpleFormIterator>
        </ArrayInput>


    </FormTab>


}

const DeductionForm = ({ formData, getSource, source, scopedFormData, ...rest }) => {
    //console.log("indei",index)
    const form = useForm();

    const { data: templates } = useQueryWithStore({
        type: 'getList',
        resource: 'deductions',
        payload: { filter: { filter: `Scope eq 'Template'` }, pagination: {}, sort: {} }
    });

    // const { loaded, error, data: loans } = useQueryWithStore({
    //     type: 'getList',
    //     resource: 'loans',
    //     payload: {filter:{filter:`employeeId eq ${formData.employeeId} and LoanStatus eq 'Standing'`},pagination:{},sort:{}}
    // });

    if (!scopedFormData) {
        return null
    }

    return <Fragment>

        <SelectInput onChange={event => {
            const item = templates.find(e => e.id === event.target.value)
            form.change(getSource('name'), item.name)
            form.change(getSource('deductionType'), item.deductionType)
            form.change(getSource('valueType'), item.valueType)
            form.change(getSource('basedOn'), item.basedOn) 
            form.change(getSource('currency'), item.currency)
            // form.change('templateId',item.id)

        }}   {...rest} label="Template" source={getSource("templateId")} choices={templates} />



        <SelectInput source={getSource("deductionType")}  {...rest} onChange={value => {
            form.change(getSource('name'), deductionChoices.find(c => c.id === value.target.value).name)
            form.change(getSource('cash'), deductionChoices.find(c => c.id === value.target.value).id === 'loan')
        }
        } choices={deductionChoices} label='Deduction Type' />

        <TextInput {...rest} label='Name' source={getSource("name")} />

        {scopedFormData.deductionType !== 'IncomeTax' && (
            <Fragment>
                <SelectInput {...rest} label='Value Type' source={getSource("valueType")} choices={[
                    { id: 'Absolute', name: 'Absolute' },
                    { id: 'Percentage', name: 'Percentage' },
                    { id: 'NetPercentage', name: 'Percentage From Net' },
                ]} />

                {/*<NumberInput {...rest} source="value" />*/}

                <NumberInput format={v => (scopedFormData.valueType || '').includes("Percentage") ? (v * 1000000) / 10000 : v} parse={v => (scopedFormData.valueType || '').includes("Percentage") ? v / 100 : v}  {...rest} label="Value" source={getSource("value")} />
                <DateInputO source={getSource("startDate")} label="Start date" options={{ format: 'DD/MM/YYYY', inputVariant: 'filled', clearable: true }} />

                {(scopedFormData.deductionType === 'Other' || scopedFormData.deductionType === 'loan') &&
                    <BooleanInput  {...rest} label='Cash' source={getSource("cash")} />
                }
            </Fragment>
        )}




    </Fragment>
}


const EmployeeDeductions = props => {

    return <FormTab {...props} label="Deductions">

        <ArrayInput source="deductions">
            <SimpleFormIterator>
                <FormDataConsumer>
                    {formDataProps => (
                        <DeductionForm {...formDataProps} />
                    )}
                </FormDataConsumer>
                {/*<TextInput label="Name" source="name" />*/}
                {/*<SelectInput label="Value Type"  source="valueType"  choices={[*/}
                {/*    { id: 'Absolute', name: 'Absolute' },*/}
                {/*    { id: 'Percentage', name: 'Percentage' },*/}
                {/*]}  />*/}

                {/*<NumberInput  label="Value"  source="value" />*/}
            </SimpleFormIterator>
        </ArrayInput>


    </FormTab>


}

const ExpenseForm = ({ formData, getSource, source, scopedFormData, ...rest }) => {
    //console.log("indei",index)
    const form = useForm();

    const { data: templates } = useQueryWithStore({
        type: 'getList',
        resource: 'expenses',
        payload: { filter: { filter: `Scope eq 'Template'` }, pagination: {}, sort: {} }
    });
    // const { loaded, error, data: loans } = useQueryWithStore({
    //     type: 'getList',
    //     resource: 'loans',
    //     payload: {filter:{filter:`employeeId eq ${formData.employeeId} and LoanStatus eq 'Standing'`},pagination:{},sort:{}}
    // });

    if (!scopedFormData) {
        return null
    }

    return <Fragment>
        <SelectInput onChange={event => {
            const item = templates.find(e => e.id === event.target.value)
            form.change(getSource('name'), item.name)
            form.change(getSource('type'), item.type)
            form.change(getSource('valueType'), item.valueType)
            form.change(getSource('basedOn'), item.basedOn)
            form.change(getSource('currency'), item.currency)
            // form.change('templateId',item.id)
        }}   {...rest} label="Template" source={getSource("templateId")} choices={templates} />



        <SelectInput {...rest} label='Expense Type' source={getSource("type")} onChange={value => form.change(getSource("name"), expenseChoices.find(c => c.id === value.target.value).name)} choices={expenseChoices} />
        <TextInput {...rest} label='Name' source={getSource("name")} />



        <SelectInput {...rest} label='Value Type' source={getSource("valueType")} choices={[
            { id: 'Absolute', name: 'Absolute' },
            { id: 'Percentage', name: 'Percentage' },
        ]} />

        {/*<NumberInput {...rest} source="value" />*/}

        <NumberInput format={v => (scopedFormData.valueType || '').includes("Percentage") ? (v * 1000000) / 10000 : v} parse={v => (scopedFormData.valueType || '').includes("Percentage") ? v / 100 : v}  {...rest} label="Value" source={getSource("value")} />


        <DateInputO source={getSource("startDate")} label="Start date" options={{ format: 'DD/MM/YYYY', inputVariant: 'filled', clearable: true }} />






    </Fragment>
}




const EmployeeExpenses = props => {

    return <FormTab {...props} label="Expenses">

        <ArrayInput source="expenses">
            <SimpleFormIterator>
                <FormDataConsumer>
                    {formDataProps => (
                        <ExpenseForm {...formDataProps} />
                    )}
                </FormDataConsumer>

            </SimpleFormIterator>
        </ArrayInput>
        {/*<ArrayInput  source="expenses">*/}
        {/*    <SimpleFormIterator>*/}
        {/*        <TextInput label="Name" source="name" />*/}
        {/*        <SelectInput label="Value Type"  source="valueType"  choices={[*/}
        {/*            { id: 'Absolute', name: 'Absolute' },*/}
        {/*            { id: 'Percentage', name: 'Percentage' },*/}
        {/*        ]}  />*/}

        {/*        <NumberInput label="Value"  source="value" />*/}
        {/*    </SimpleFormIterator>*/}
        {/*</ArrayInput>*/}


    </FormTab>


}



export const EmployeeCreate = props => {
    // const form = useForm();

    return (
        <Create {...props}>
            <TabbedForm redirect='list' >
                <FormDataConsumer>
                    {formDataProps => (
                        <EmployeeBasic create {...formDataProps} />
                    )}
                </FormDataConsumer>

                <AddressTab />
                {/*<EmployeeBasic/>*/}
                <EmployeeEarning />
                <EmployeeDeductions />
                <EmployeeExpenses />
                <FormDataConsumer>
                    {formDataProps => (
                        <MiscForm create {...formDataProps} />
                    )}
                </FormDataConsumer>

                {/*<FormTab    label="Basic">*/}
                {/*<ReferenceInput filter={{"expand":"earnings"}} label="Position" source="positionId" reference="positions" validate={[required()]}>*/}
                {/*<SelectInput   optionText="name"  />*/}
                {/*</ReferenceInput>*/}
                {/*<TextInput source="name" />*/}
                {/*<TextInput    source="fatherName" />*/}
                {/*<TextInput   source="gFatherName" />*/}



                {/*</FormTab>*/}
                {/*<FormTab  label="Advanced">*/}
                {/*<ArrayInput source="earnings">*/}
                {/*<SimpleFormIterator>*/}
                {/*<TextInput  label="Name" source="name" />*/}
                {/*</SimpleFormIterator>*/}
                {/*</ArrayInput>*/}
                {/*/!*<FormSpy*!/*/}
                {/*/!*subscription={{values: true }}*!/*/}
                {/*/!*onChange={props => {*!/*/}
                {/*/!*console.log('Form validity changed to', props.values)*!/*/}
                {/*/!*}}*!/*/}
                {/*/>*/}

                {/*</FormTab>*/}


                {/*<OnChange name="name">*/}
                {/*{value => {*/}
                {/*console.log(value)*/}
                {/*}}*/}
                {/*</OnChange>*/}

            </TabbedForm>
        </Create>
    )
};


const AddNewLoanButton = ({ record }) => (
    <Button
        component={Link}
        to={{
            pathname: "/loans/create",
            search: `?employeeId=${record.id}&&source=1`,
            // search: `?source=${JSON.stringify({ scopeId: record.id,scope})}`,
        }}
        label="Add Loan"
    >
        <AddIcon />
    </Button>
);

const AddNewAccountButton = ({ record }) => (
    <Button
        component={Link}
        to={{
            pathname: "/accounts/create",
            search: `?employeeId=${record.id}`,
            // search: `?source=${JSON.stringify({ scopeId: record.id,scope})}`,
        }}
        label="Add Account"
    >
        <AddIcon />
    </Button>
);

//CostAllocation
const AddCostAllocationButton = ({ record }) => (
    <Button
        component={Link}
        to={{
            pathname: "/employeeCostCenterAllocations/create",
            search: `?employeeId=${record.id}`,
        }}
        label="Add Cost Allocation"
    >
        <AddIcon />
    </Button>
);


const EditLoanButton = ({ type, record, id }) => (
    <Button
        component={Link}
        to={{
            pathname: `/loans/${record.id}`,
            search: `?employeeId=${id}&&source=1`,
            //search: `?source=${JSON.stringify({ scopeId: record.id,scope})}`,
        }}
        label="Edit"
    >
        <EditIcon />
    </Button>
);

const EmployeeBasicShow = ({ source, record = {} }) => {
    if (!record) {
        return null;
    }
    return <div>
        <Grid container direction="column">
            <Grid item container spacing={10}>
                <Grid item><CaptionedField label="Work Id" value={record.orgID} style="text" /></Grid>
                {record.mateId && <Grid item><CaptionedField label="Mate Id" value={record.mateId} style="text" /></Grid>}
                {record.address && <Grid item><CaptionedField label="Email" value={record.address.email} style="text" /></Grid>}
            </Grid>
            <Typography size="xl"  >
                {record.title}  {record.name}  {record.fatherName}  {record.gFatherName}
            </Typography>

            <Grid item container spacing={10} >
                <Grid item><CaptionedField defaultCurrency={record.defaultCurrency} label="Basic Salary" value={record.basicSalary} /></Grid>
                <Grid item><CaptionedField label="Employment Type" value={record.employmentType} style="text" /></Grid>
                <Grid item><CaptionedField label="Citizenship" value={record.citizenship} style="text" /></Grid>
            </Grid>
            <Grid item container spacing={10} >
                <Grid item><CaptionedField label="Start Date" style="text" value={record.startDate ? moment(record.startDate).format("MMM DD YYYY") : ''} /></Grid>
                {record.contractEndDate && moment(record.contractEndDate) > moment("1970/1/1") && <Grid item><CaptionedField label="Contract End Date" style="text"
                    value={moment(record.contractEndDate).format("MMM DD YYYY")} /></Grid>
                }
            </Grid>
            <Grid item container spacing={10} >
                <Grid item><CaptionedField label="Tin No" style="text" value={record.tinNo} /></Grid>
                <Grid item><CaptionedField label="Pension No" style="text" value={record.pensionNo} /></Grid>
            </Grid>

            <Grid item container spacing={10} >
                {/*<Grid item><CaptionedField label="Bank"  style="text" value={record.bank.name}/></Grid>*/}
                <Grid item><CaptionedField label="Bank Account No" style="text" value={record.bankAccountNumber} /></Grid>
            </Grid>

        </Grid>
    </div>
}

export const EmployeeShow = props => (

    <Show {...props}>
        <TabbedShowLayout>
            <Tab label="Basic Info">
                <EmployeeBasicShow />
                {/* <TextField  label='Work Id'  source="orgID" />*/}

                {/* <TextField source="name" />*/}
                {/*<TextField  source="fatherName" />*/}
                {/* <TextField  source="gFatherName" />*/}

                {/* <TextField source="basicSalary" />*/}
                {/* <TextField  label='Email' type='email' source="address.email" />*/}
                {/* <TextField  label='Mate Id' type='email' source="mateId" />*/}
                {/* <TextField   source="tinNo" />*/}
                {/* <TextField source="pensionNo" />*/}

                {/* <TextField source="employmentType" />*/}

                {/* <DateField source="startDate" />*/}
                {/* <ConditionalField source="contractEndDate" />*/}

                {/*<DateField source="contractEndDate" />*/}


            </Tab>
            <AddressTabShow />
            {/*adjustment tab*/}
            <Tab label="Adjustments" path="employeeAdjustments">
                <ReferenceManyField
                    addLabel={false}
                    reference="employeeAdjustments"
                    target="employees"
                >
                    <Datagrid>
                        <DateField source="effectiveDate" />
                        <TextField source="adjustmentType" />
                        <TextField source="name" />
                        <AdjustmentValueField source="value" />
                        <AdjustmentValueField source="oldValue" />
                        <TextField source="status" />
                        <ApproveButton />
                        <PendingEditButtonWithEmployeeId employeeId={props.id} />
                    </Datagrid>
                </ReferenceManyField>
                <AddNewAdjustmentButton />
            </Tab>
            {/*adjustment tab*/}
            <Tab label="Additional Earnings" path="earnings">

                <ReferenceManyField
                    addLabel={false}
                    reference="earnings"
                    target="employees"


                >
                    <Datagrid>
                        <TextField source="name" />
                        <TextField source="valueType" />
                        <PercentField source="value" />
                        <EditXButton type="earnings" scope={2} id={props.id} />
                        <DeleteButton basePath={`/employees/${props.id}/show/earnings`} />

                    </Datagrid>
                </ReferenceManyField>
                <AddItemButton label={"Add an Earning"} path="/earnings/create" scope={2} />


            </Tab>
            <Tab label="Deductions" path="deductions">
                <ReferenceManyField
                    addLabel={false}
                    reference="deductions"
                    target="employees"

                >
                    <Datagrid >
                        <TextField source="name" />
                        <TextField source="valueType" />
                        <PercentField source="value" />
                        <EditXButton type="deductions" scope={2} id={props.id} />
                        <DeleteButton basePath={`/employees/${props.id}/show/deductions`} />
                    </Datagrid>
                </ReferenceManyField>
                <AddNewDeductionButton scope={2} />

            </Tab>
            <Tab label="Expenses" path="expenses">
                <ReferenceManyField
                    addLabel={false}
                    reference="expenses"
                    target="employees"
                >
                    <Datagrid >
                        <TextField source="name" />
                        <TextField source="valueType" />
                        <PercentField source="value" />
                        <EditXButton type="expenses" scope={2} id={props.id} />
                        <DeleteButton basePath={`/employees/${props.id}/show/expenses`} />
                    </Datagrid>
                </ReferenceManyField>
                <AddNewExpenseButton scope={2} />

            </Tab>
            <Tab label="Loans" path="loans">
                <ReferenceManyField
                    addLabel={false}
                    reference="loans"
                    target="employees"
                >
                    <Datagrid >
                        <TextField source="name" />
                        <TextField source="type" />
                        <NumberField source="requestedAmount" />
                        {/*<EditButton/> because of redirect*/}
                        <ShowButton />
                        <EditLoanButton id={props.id} />

                    </Datagrid>
                </ReferenceManyField>
                <AddNewLoanButton />

            </Tab>
            <Tab label="Accounts" path="accounts">
                <ReferenceManyField
                    addLabel={false}
                    reference="accounts"
                    target="employees"
                >
                    <Datagrid >
                        <TextField source="code" />
                        <TextField source="name" />
                        <TextField source="category" />
                        <TextField source="templateType" />
                        {/*<TemplateField/>*/}
                        <ShowButton />
                        <EditButton />


                    </Datagrid>
                </ReferenceManyField>
                <AddNewAccountButton />

            </Tab>
            <Tab label="Cost Center Allocations" path="employeeCostCenterAllocations">
                <ReferenceManyField
                    addLabel={false}
                    reference="employeeCostCenterAllocations"
                    target="employees"  
                >
                    <Datagrid>
                    
                        <ReferenceField label="Cost Center" source="costCenterId" reference="costCenters">
                            <TextField source="code" />
                        </ReferenceField>
                        <PercentField source="allocationPercentage" />
                        <TextField source="remarks" />
                   
                        <EditButtonWithEmployeeId type="employeeCostCenterAllocations"  employeeId={props.id} />

                    </Datagrid>
                </ReferenceManyField>
                
                <TotalAllocationPercentage employeeId={props.id} />
                <AddCostAllocationButton />
            </Tab>
            <Tab label="Events" path="events">
                <ReferenceManyField
                    addLabel={false}
                    reference="events"
                    target="employees"
                >
                    <Datagrid>
                        <TextField source="eventType" />
                        <DateField source="startDate" />
                        <DateField source="endDate" />
                        <TextField source="description" />
                        <EditButtonWithEmployeeId type="events" employeeId={props.id} />
                        <DeleteButton basePath={`/employees/${props.id}/show/events`} />
                    </Datagrid>
                </ReferenceManyField>
                <AddNewEventButton record={{ id: props.id }} />
            </Tab>
        </TabbedShowLayout>
    </Show>
);

const TemplateField = props => {
    const category = props.record['category']

    return <ReferenceField source="templateId" reference={category === 'loans' ? "loanTemplates" : category} {...props}>
        <TextField source="name" />
    </ReferenceField>
}

const TotalAllocationPercentage = ({ employeeId }) => {
    const { loaded, error, data: allocations} = useQueryWithStore({
        type: 'getList',
        resource: 'employeeCostCenterAllocations',
        payload: {filter:{filter:`employeeId eq ${employeeId}`}}
    });     

    const { data: costCenters } = useQueryWithStore({
        type: 'getList',
        resource: 'costCenters',
        payload: {filter:{},pagination:{},sort:{}}
    });

    // console.log(costCenters, "costCenters", allocations, "allocations")

    if (!loaded || !costCenters) return null;

    const total = allocations ? allocations.reduce((sum, allocation) => 
        sum + (allocation.allocationPercentage || 0), 0) : 0;

    const chartData = allocations ? allocations.map(allocation => {
        const costCenter = costCenters.find(cc => cc.id === allocation.costCenterId);
        return {
            name: costCenter ? costCenter.name : 'Unknown',
            value: allocation.allocationPercentage,
            percentage: (allocation.allocationPercentage * 100).toFixed(1)
        };
    }) : [];

    if (total < 1) {
        chartData.push({
            name: 'Unallocated',
            value: 1 - total,
            percentage: ((1 - total) * 100).toFixed(1)
        });
    }

    const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#8884D8', '#82CA9D'];

    const CustomTooltip = ({ active, payload }) => {
        if (active && payload && payload.length) {
            return (
                <div style={{ 
                    backgroundColor: '#fff', 
                    padding: '10px', 
                    border: '1px solid #ccc',
                    borderRadius: '4px'
                }}>
                    <p>{`${payload[0].name}: ${payload[0].payload.percentage}%`}</p>
                </div>
            );
        }
        return null;
    };

    return (
        <Box display="flex" flexDirection="column" alignItems="center" mb={2}>
            <Typography 
                variant="h5" 
                style={{ 
                    color: Math.abs(total - 1) < 0.01 ? '#4caf50' : '#f44336',
                    fontWeight: 'bold',
                    marginBottom: '16px'
                }}
            >
                Total Allocation: {(total*100).toFixed(2)}%
            </Typography>
            
            <div style={{ width: '300px', height: '300px' }}>
                <ResponsiveContainer>
                    <PieChart>
                        <Pie
                            data={chartData}
                            innerRadius={90}
                            outerRadius={150}
                            paddingAngle={1}
                            dataKey="value"
                            nameKey="name"
                            label={({ name, percentage }) => `${name}: ${percentage}%`}
                        >
                            {chartData.map((entry, index) => (
                                <Cell 
                                    key={`cell-${index}`} 
                                    fill={COLORS[index % COLORS.length]}
                                />
                            ))}
                        </Pie>
                        <Tooltip content={<CustomTooltip />} />
                    </PieChart>
                </ResponsiveContainer>
            </div>
        </Box>
    );
};

const AddNewAdjustmentButton = ({ record }) => (
    <Button
        component={Link}
        to={{
            pathname: "/employeeAdjustments/create",
            search: `?employeeId=${record.id}`,
        }}
        label="Add Adjustment"
    >
        <AddIcon />
    </Button>
);

const PendingEditButtonWithEmployeeId = ({ record, employeeId, ...rest }) => 
    record  && (
        <EditButtonWithEmployeeId 
            record={record} 
            type="employeeAdjustments" 
            employeeId={employeeId} 
            {...rest} 
        />
    )
